import { PixelPlaceholderLoader } from "@similarweb/ui-components";

export const LOADER_GRADIENT_ID = "loaderGradient";
export const LOADER_GREY_GRADIENT_ID = "loaderGreyGradient";

const Gradient = () => (
    <linearGradient
        id={LOADER_GRADIENT_ID}
        x1="0%"
        x2="0%"
    >
        <animate
            attributeName="x1"
            dur="1s"
            repeatCount="indefinite"
            from="0%"
            to="200%"
        />
        <stop
            offset="0%"
            stopColor="#D8E4F5"
        />
        <stop
            offset="50%"
            stopColor="#CFDBEC"
        />
        <stop
            offset="100%"
            stopColor="#D8E4F5"
        />
    </linearGradient>
);

const GreyGradient = () => (
    <linearGradient
        id={LOADER_GREY_GRADIENT_ID}
        x1="0%"
        x2="0%"
    >
        <animate
            attributeName="x1"
            dur="1s"
            repeatCount="indefinite"
            from="0%"
            to="200%"
        />
        <stop
            offset="0%"
            stopColor="#f6f7f9"
        />
        <stop
            offset="50%"
            stopColor="#EBF0F5"
        />
        <stop
            offset="100%"
            stopColor="#f6f7f9"
        />
    </linearGradient>
);

const LOADER_GRADIENT_MARKUP_MAP = {
    [LOADER_GRADIENT_ID]: Gradient,
    [LOADER_GREY_GRADIENT_ID]: GreyGradient,
};

const LoaderGradient = ({
    width = "100%",
    height = "100%",
    id = LOADER_GRADIENT_ID,
    className,
}: {
    width?: string | number;
    height?: string | number;
    id?: keyof typeof LOADER_GRADIENT_MARKUP_MAP;
    className?: string;
}) => {
    return (
        <PixelPlaceholderLoader
            width={width}
            height={height}
            id={id}
            ShapeMarkup={LOADER_GRADIENT_MARKUP_MAP[id]}
            className={className}
        />
    );
};

export default LoaderGradient;
